module.exports = __webpack_public_path__ + "img/bg_grid_white.e243a847.png";